var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgPatternCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 140,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".779%",
    x2: "50%",
    y2: "100%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0989B4",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53FFEE",
    offset: "99.94%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".779%",
    x2: "50%",
    y2: "100%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0989B4",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53FFEE",
    offset: "99.94%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h350v140H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#41CBD3",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 -4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 60.479 14.8)",
    cx: 60.479,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    transform: "rotate(180 14.834 14.8)",
    cx: 14.834,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 151.767,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 106.123 14.8)",
    cx: 106.123,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 243.055 14.8)",
    cx: 243.055,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    transform: "rotate(180 197.411 14.8)",
    cx: 197.411,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 334.344,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 288.7 14.8)",
    cx: 288.699,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 91.63)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 60.479 14.8)",
    cx: 60.479,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    transform: "rotate(180 14.834 14.8)",
    cx: 14.834,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 151.767,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 106.123 14.8)",
    cx: 106.123,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 243.055 14.8)",
    cx: 243.055,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    transform: "rotate(180 197.411 14.8)",
    cx: 197.411,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 334.344,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 288.7 14.8)",
    cx: 288.699,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 43.815)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 60.479 14.8)",
    cx: 60.479,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 14.834,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 151.767,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 106.123 14.8)",
    cx: 106.123,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 243.055 14.8)",
    cx: 243.055,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 197.411,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 334.344,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 288.7 14.8)",
    cx: 288.699,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.822 18.77)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 60.479 14.8)",
    cx: 60.479,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    transform: "rotate(180 14.834 14.8)",
    cx: 14.834,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 151.767,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 106.123 14.8)",
    cx: 106.123,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 243.055 14.8)",
    cx: 243.055,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    transform: "rotate(180 197.411 14.8)",
    cx: 197.411,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 334.344,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 288.7 14.8)",
    cx: 288.699,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.822 114.4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 60.479 14.8)",
    cx: 60.479,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    transform: "rotate(180 14.834 14.8)",
    cx: 14.834,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 151.767,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 106.123 14.8)",
    cx: 106.123,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 243.055 14.8)",
    cx: 243.055,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    transform: "rotate(180 197.411 14.8)",
    cx: 197.411,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 334.344,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 288.7 14.8)",
    cx: 288.699,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.822 66.585)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 60.479 14.8)",
    cx: 60.479,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 14.834,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 151.767,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 106.123 14.8)",
    cx: 106.123,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(-90 243.055 14.8)",
    cx: 243.055,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 197.411,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#d)",
    cx: 334.344,
    cy: 14.8,
    rx: 14.834,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#c)",
    transform: "rotate(90 288.7 14.8)",
    cx: 288.699,
    cy: 14.8,
    rx: 14.8,
    ry: 14.834
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternCard);
export default __webpack_public_path__ + "static/media/bg-pattern-card.b61daebd3cb4b885d10fd683755d49bb.svg";
export { ForwardRef as ReactComponent };